import { useEffect, lazy, Suspense } from 'react';
import { Box, Skeleton } from '@mui/material';

import { Container } from '~/content/components/Container';

const Headline = lazy(() => import('./headline.tsx'));
const Gallery = lazy(() => import('./gallery.tsx'));
const Numbers = lazy(() => import('./numbers.tsx'));
const Story = lazy(() => import('./story.tsx'));
const Team = lazy(() => import('./team.tsx'));

// import Subscription from './subscription';
import { trackPageview } from '~/utils/plausible';

// import {
// 	Links,
// 	Meta,
// 	Outlet,
// 	Scripts,
// 	ScrollRestoration,
// 	PrefetchPageLinks,
// 	useLoaderData,
// } from '@remix-run/react';

const about = (): JSX.Element => {
	useEffect(() => {
		trackPageview();
	}, []);

	return (
		<Box>
			{/* paddingY={"60px !important"} */}
			<Container paddingBottom={'45px !important'}>
				<Suspense fallback={<Skeleton variant='rectangular' width={'100%'} height={'100%'} />}>
					<Headline />
				</Suspense>
			</Container>

			<Container paddingY={'0 !important'}>
				<Suspense fallback={<Skeleton variant='rectangular' width={'100%'} height={'100%'} />}>
					<Gallery />
				</Suspense>
			</Container>
			<Container
				maxWidth={'1000px !important'}
				paddingTop={'70px !important'}
				// paddingBottom={'60px !important'}
			>
				<Numbers />
			</Container>
			<Container paddingTop={'50px !important'}>
				<Suspense fallback={<Skeleton variant='rectangular' width={'100%'} height={'100%'} />}>
					<Story />
				</Suspense>
			</Container>
			{/* <Container maxWidth={"800px !important"}>
				<Divider />
			</Container> */}
			<Container paddingTop={'35px !important'} paddingBottom={'85px !important'}>
				<Suspense fallback={<Skeleton variant='rectangular' width={'100%'} height={'100%'} />}>
					<Team />
				</Suspense>
			</Container>
			{/* <Container>
				<Subscription />
			</Container> */}
		</Box>
	);
};

export { about };
